<template>
  <v-card style="overflow: hidden" flat class="pa-1">
    <custom-tabs
      v-model="tabs"
      :tab-items="[
        {
          text: this.$t('create_podcast'),
          icon: 'music-circle-outline',
          value: 'voice',
        },
        { text: this.$t('add_link'), icon: 'music-note-plus', value: 'files' },
        {
          text: this.$t('upload_file'),
          icon: 'archive-music-outline',
          value: 'video',
        },
        {
          text: this.$t('file_list'),
          icon: 'folder-music-outline',
          value: 'sound',
        },
      ]"
      grow
    >
      <template v-slot:staticItems>
        <v-tab-item style="position: relative">
          <v-card flat class="pa-2" style="opacity: 1" >
            <create-audio @onVoiceCreated="handleVoiceCreated" />

          </v-card>
        </v-tab-item>
        <v-tab-item>
          <add-link-audio :audioSelects="audioSelects" />
        </v-tab-item>
        <v-tab-item>
          <upload-audio
            v-model="tabs"
            @update="getSound"
            :category="category"
          />
        </v-tab-item>
        <v-tab-item>
          <audio-list
            :category="category"
            :audios="audios"
            :audioSelects="audioSelects"
            :loading="loading"
            :dialog="dialog"
            v-model="fileComputed"
          />
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import { Bus } from "../../../../../main";
import AddLinkAudio from "./addLinkAudio.vue";
import AudioList from "./audioList.vue";
import createAudio from "./createAudio.vue";
import UploadAudio from "./uploadAudio.vue";
import { ir } from "../../../../../check_domain_ir";

export default {
  components: { createAudio, AddLinkAudio, UploadAudio, AudioList },
  name: "audioGallery",
  props: {
    value: Array,
    audioSelects: [Array],
    dialog: [Boolean],
  },

  data() {
    return {
      tabs: null,
      loading: false,
      url: process.env.VUE_APP_ROBOT,
      audios: [],
      category: [],
      updateList: false,
    };
  },

  watch: {
    dialog: {
      deep: true,
      handler(val) {
        if (val) {
          this.fileComputed = this.audioSelects;
          this.tabs = 0;
        }
      },
    },
  },

  mounted() {
    this.getSound();
    Bus.$on("updateList", (val) => {
      if (val) {
        this.getSound();
      }
    });
  },

  computed: {
    fileComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
     handleVoiceCreated(file) {
      if (!file) return;

      const vm = this;
      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = ir(this.url);

      let formData = new FormData();
      formData.append("file", file);
      formData.append("file_type", "other");
      formData.append("category", 'ضبط صدا');
      formData.append("type", "other");
      formData.append("file_type", "audio");

      if (this.$toast) this.$toast.info("در حال آپلود فایل صوتی...");

      $.ajax({
        url: `${local_url}/files`,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (response) => {
          if (vm.$toast) vm.$toast.success("صدا با موفقیت ذخیره شد");
          
          vm.getSound(); 

          vm.tabs = 3; 

          if (response && response.data) {
             let uploadedFile = response.data;
             vm.fileComputed = [uploadedFile]; 
          }
        },
        error: (err) => {
          if (vm.$toast) vm.$toast.error("خطا در آپلود صدای ضبط شده");
          console.error("Upload error:", err);
        },
      });
    },
    getSound() {
      const vm = this;
      this.loading = true;
      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = ir(this.url);

      $.ajax({
        url: `${local_url}/files`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: {
          file_type: "audio",
          paginate: 1,
          dir: "desc",
          //   page: this.next_page,
          // category:
          //   this.search === "" || this.search === null
          //     ? undefined
          //     : this.search,
        },
        type: "GET",
        success: (data) => {
          // this.cats = data.data.categories;
          // if (data.data.items.next_page_url) {
          //   this.observer.observe(this.$refs.dl);
          //   this.next_page = data.data.items.current_page + 1;
          // } else this.next_page = null;

          // this.img = [...this.img, ...data.data.items.data];
          vm.audios = data.data.items.data;
          vm.category = data.data.categories;
          vm.fileComputed = this.audioSelects;

          this.loading = false;
        },
      });
    },
  },
};
</script>

<style></style>
